import { LoadablePaint } from '@confluence/loadable';

export const TemplateGalleryLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplateGallery" */ './TemplateGallery'))
			.TemplateGallery,
});
